import { $api } from '../y/api';

export type XNetworkAccessGroup = 'aurora' | 'backend';

export interface XNetworkAccessEntry {
    group: XNetworkAccessGroup;
    group_id: string;
    id: string;
    port_from: number;
    port_to: number;
    protocol: string;
    ip_block: string;
    description: string;
}

export interface XNetworkAccessResponse {
    entries: XNetworkAccessEntry[];
    your_ip: string;
}

export function xNetworkAccessGetAll(): Promise<XNetworkAccessResponse> {
    return $api.GET<XNetworkAccessResponse>('x/network_access');
}

export function xNetworkAccessCreate(params: { group: XNetworkAccessEntry, ip: string; port: number; protocol: string; description: string }): Promise<void> {
    return $api.POST('x/network_access', params);
}

export function xNetworkAccessDelete(group: string, id: string) {
    return $api.DELETE(`x/network_access/${group}/${id}`);
}
